import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=e80572b6&lang=pug"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports